module.exports = __webpack_public_path__ + "img/sidebar-left.c4262aaa.png";